const InfoIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" fill="white" stroke={color} />
      <path
        d="M8.68827 3.66L8.53227 9.48H7.39227L7.23627 3.66H8.68827ZM8.00427 12.084C7.75627 12.084 7.54827 12 7.38027 11.832C7.21227 11.664 7.12827 11.456 7.12827 11.208C7.12827 10.96 7.21227 10.752 7.38027 10.584C7.54827 10.416 7.75627 10.332 8.00427 10.332C8.24427 10.332 8.44827 10.416 8.61627 10.584C8.78427 10.752 8.86827 10.96 8.86827 11.208C8.86827 11.456 8.78427 11.664 8.61627 11.832C8.44827 12 8.24427 12.084 8.00427 12.084Z"
        fill={color}
      />
    </svg>
  );
};

export default InfoIcon;
